import consumer from "./consumer"

document.addEventListener('DOMContentLoaded', () => {
  // Function to subscribe to a specific transaction ID
  window.subscribeToMqttMessage = function(transactionId) {
    console.log(`Subscribing to MQTT message with transaction ID: ${transactionId}`);
    
    // Create a subscription for this transaction ID
    const subscription = consumer.subscriptions.create(
      { 
        channel: "MqttMessageChannel", 
        transaction_id: transactionId 
      }, 
      {
        connected() {
          // Called when the subscription is ready for use on the server
          console.log(`Connected to MqttMessageChannel for transaction ID: ${transactionId}`);
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
          console.log(`Disconnected from MqttMessageChannel for transaction ID: ${transactionId}`);
        },

        received(data) {
          // Called when there's incoming data on the websocket for this channel
          console.log(`Received MQTT message for transaction ID: ${data.transaction_id}`);
          
          // Get the MQTT message from the data
          const mqttMessage = data.mqtt_message;
          
          // Create a new measurement response element
          const responseElement = document.createElement('div');
          responseElement.className = 'list-group-item';
          
          // Extract data from the MQTT message
          const payload = mqttMessage.payload;
          const receivedAt = new Date(mqttMessage.received_at);
          const formattedDate = receivedAt.toLocaleDateString() + ' ' + receivedAt.toLocaleTimeString();
          
          // Extract field module information if available
          let fieldModuleName = "Unknown";
          let fieldModuleId = null;
          
          if (payload.result && payload.result.fmSerial) {
            // Try to find the field module in the DOM
            const fieldModuleElements = document.querySelectorAll('.list-group-item');
            for (const element of fieldModuleElements) {
              const link = element.querySelector('a');
              if (link && link.textContent.includes(payload.result.fmSerial)) {
                fieldModuleName = link.textContent;
                fieldModuleId = link.getAttribute('href').split('/').pop();
                break;
              }
            }
          }
          
          // Build the HTML for the response
          let html = `
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong>Feldmodul:</strong> ${fieldModuleId ? `<a href="/field_modules/${fieldModuleId}">${fieldModuleName}</a>` : fieldModuleName}
              </div>
              <div>
                <strong>Empfangen am:</strong> ${formattedDate}
              </div>
            </div>
            <div class="mt-2">
          `;
          
          // Add result or error information
          if (payload.result) {
            html += `
              <div class="alert alert-success">
                <strong>Status:</strong> Erfolgreich
              </div>
            `;
            
            if (payload.result.data) {
              html += `
                <div class="mt-2">
                  <strong>Daten:</strong>
                  <pre><code class="json">${JSON.stringify(payload.result.data, null, 2)}</code></pre>
                </div>
              `;
            }
          } else if (payload.error) {
            html += `
              <div class="alert alert-danger">
                <strong>Status:</strong> Fehler
                <div><strong>Code:</strong> ${payload.error.code}</div>
                <div><strong>Nachricht:</strong> ${payload.error.message}</div>
              </div>
            `;
          }
          
          html += '</div>';
          responseElement.innerHTML = html;
          
          // Add the response to the measurement responses list
          const responsesList = document.querySelector('#measurement_responses .list-group');
          if (responsesList) {
            // Add the new response at the top
            responsesList.insertBefore(responseElement, responsesList.firstChild);
          } else {
            // If there's no list yet, create one
            const responsesContainer = document.getElementById('measurement_responses');
            if (responsesContainer) {
              const newList = document.createElement('div');
              newList.className = 'list-group';
              newList.appendChild(responseElement);
              
              // Replace the "no responses" message if it exists
              const noResponsesMessage = responsesContainer.querySelector('p');
              if (noResponsesMessage && noResponsesMessage.textContent.includes('Keine')) {
                responsesContainer.replaceChild(newList, noResponsesMessage);
              } else {
                responsesContainer.appendChild(newList);
              }
            }
          }
          
          // Unsubscribe after receiving the message
          this.consumer.subscriptions.remove(this);
        }
      }
    );
    
    return subscription;
  };
});